
import Vue from "vue";
import { Sale, SaleHistory } from "@/models/base";
import { getFileUrl } from "@/utils/url";

export default Vue.extend({
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		url():string{
			return getFileUrl(this.event.Props[0]);
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
